import { IRevenueAgencyCrudModalLang } from '../../../types/lang'

export const revenueAgencyCrudModalLang: IRevenueAgencyCrudModalLang = {
	revenue_agency_crud_modal: {
		title_create: 'Create revenue agency_ru',
		title_edit: 'Edit revenue agency_ru',
		title_remove_single: 'Remove <span>revenue agency_ru</span>',
		title_notes_view: 'View notes for revenue agency_ru',
		title_notes_edit: 'Edit notes for revenue agency_ru',
		title_history_view: 'View history in revenue agency_ru',
		field_name_label: 'Name_ru',
		field_name_placeholder: 'Name_ru',
		field_group_label: 'Group_ru',
		field_group_placeholder: 'Group_ru',
		field_fake_type_label: 'Fake Type_ru',
		field_fake_type_placeholder: 'Fake Type_ru',
		field_date_label: 'Date_ru',
		field_date_placeholder: 'Date_ru',
		field_percent_label: 'Percent, %_ru',
		field_percent_placeholder: 'Percent, %_ru',
		field_is_system_label: 'System_ru',
		field_is_active_label: 'Active_ru',
		field_is_hold_label: 'Hold_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		btn_add_record: 'Add Record_ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}